module.exports = __webpack_public_path__ + "img/oefenen-btn.f4806580.png";